module.exports = __webpack_public_path__ + "img/good-session-4.c0e55eef.png";